import { signOut } from "firebase/auth";
import { useContext } from "react";
import { AppContext } from "../../context/AppProvider";

const DiagPage = (props) => {
  const appState = useContext(AppContext);

  const handleReset = () => {
    if (window.confirm("Reset app data?")) {
      localStorage.clear();
      window.location.href = "/";
      //window.location.reload();
    }
  };

  const handleLogout = () => {
    if (appState.firebase && appState.firebase.auth) {
      if (window.confirm("Reset app data?")) {
        signOut(appState.firebase.auth)
          .then(() => {
            window.location.href = "/";
          })
          .catch((err) => {
            window.alert(`Error signing out ${err}`);
          });
      }
    } else {
      window.alert("Firebase object is not available to sign out");
      
    }
  };

  return (
    <div
      style={{
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "10px",
        marginBottom: "10px",
        width: "95%",
        padding: "10px",
        borderRadius: "10px",
        backgroundColor: "rgba(100,100,100,.75)",
      }}
    >
      <h1>Diagnostics</h1>
      <h2>Stored State</h2>
      <p>{localStorage.getItem("app_state")}</p>
      <button className="btn btn-danger" onClick={handleReset}>
        Reset
      </button>
      <h2>Live State</h2>
      <p>{appState.live && JSON.stringify(appState.live)}</p>
      <h2>Firebase Account</h2>
      <button className="btn btn-danger" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
};

export { DiagPage };
